import { render, staticRenderFns } from "./CreateContactBtn.vue?vue&type=template&id=282879ca&"
import script from "./CreateContactBtn.vue?vue&type=script&lang=js&"
export * from "./CreateContactBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports